<template>
  <div>
    <b-list-group-item @click="toggleExpandFleet(fleet.id)" v-b-toggle="'collapse' + fleet.id" class="font-weight-bold bg-light text-uppercase small" style="cursor: pointer">
      <i class="fa fa-circle" :style="{ color: '#' + fleet.color }"></i>&nbsp;&nbsp;&nbsp;{{ fleet.name }} <span class="badge badge-success" style="float:right">{{ fleet.contracts.length }}</span>
    </b-list-group-item>
    <b-collapse :visible="isFleetExpanded(fleet.id) || searching" :id="'collapse' + fleet.id">
      <Vehicle v-for="contract in fleet.contracts" :contract="contract" :key="contract.id" />
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressGeocoder from '@/components/AddressGeocoder.vue';
import Vehicle from '@/components/Vehicle.vue';
import {
  TOGGLE_EXPAND_FLEET,
} from '@/store/mutation-types';

export default {
  name: 'fleet',
  props: ['fleet', 'contracts', 'searching'],
  components: {
    AddressGeocoder,
    Vehicle,
  },
  methods: {
    toggleExpandFleet: function(fleetId) {
      this.$store.commit(TOGGLE_EXPAND_FLEET, fleetId);
    }
  },
  computed: {
    ...mapGetters([
        'expandedFleets',
        'selectedContract',
        'isFleetExpanded',
      ]),
  }
}
</script>

<style scoped>
</style>
